/*
 * Validator 简介
 *  - Validator 主要是提供对 form 表单的验证功能。使用 el-form 并且结合 async-validator 框架实现。这里的 Validator 主要提供 aysn-validate
 *    所需要的验证方法句柄。
 *
 * 如何结合异步验证是最大的难点，这里采用 lodash 的 debounce 来减少 axios 的发送频率；
 *  - 背景
 *    作为用户，我期望注册的时候，在我输入用户名或者邮箱的时候，能够实时的检测出该用户名或者邮箱是否已经被注册！
 *  - 难点
 *    这需要结合 change 事件，但是我们知道 change 事件是实时发生的，也就是每当用户敲击键盘就会触发！因此通过 loadash 的 debounce 功能可以有效
 *    的减少向后台发送验证的请求。
 */

// 注意 @shangyang/validator 是使用 commonjs 规范导出的，如果使用 ES6 的规范导入会报错 shangyang_validator___default.a.validatePassword is not a function
var {Validator, Message} = require("@shangyang/validator");
import util from 'util';
import {isUsernameValid, isEmailExists, verifyEmailActivaiteCode, checkPassword} from "./data/user";
import {isValid} from "./data/invitecode";

function _isUsernameValid(username, callback){
    isUsernameValid(username).then((r)=>{
        if(!r.pass)
            callback(new Error(r.error));
        else
            callback();
    }).catch((error)=>{
        console.log(error);
    });
}

function _checkEmailDuplicates(email, callback){
    isEmailExists(email).then((exists)=>{
        if(exists)
            callback(new Error(Message.ERROR_EMAIL_DUPLICATE));
        else
            callback();
    }).catch((error)=>{
        console.log(error);
    });
}

function _isEmailExists(email, callback){
    isEmailExists(email).then((exists)=>{
        if(exists)
            callback();
        else
            callback(new Error(Message.ERROR_EMAIL_NOT_EXISTS));
    }).catch((error)=>{
        console.log(error);
    });
}

function _checkPassword(password, callback){
    checkPassword(password).then(isValid=>{
        if(!isValid){
            callback(new Error('与原密码不匹配，请重新输入'));
        }else{
            callback();
        }
    })
}

const DEBOUNCE_DELAY_TIME = 600; // ms

const __isUsernameValid = _.debounce(_isUsernameValid, DEBOUNCE_DELAY_TIME);
const __checkEmailDuplicates = _.debounce(_checkEmailDuplicates, DEBOUNCE_DELAY_TIME);
const __isEmailExists = _.debounce(_isEmailExists, DEBOUNCE_DELAY_TIME);
const __checkPassword = _.debounce(_checkPassword, DEBOUNCE_DELAY_TIME);

/**
 * 这个是 Register 页面为了支撑 system auto gen username 的做法，因此还需要判断 radio 的值
 * @param rule
 * @param username
 * @param callback
 */
export function validateUsername1(rule, username, callback){
    if(this.radio === 0 ) // 这是表示 system auto gen
        callback();
    else if(this.radio === 1){ // 用户手动输入，那么需要验证
        validateUsername(rule, username, callback);
    }
}

/**
 * 注意，要能够复用，则表单的名字必须统一，这里使用 vform
 *
 * @param rule
 * @param username
 * @param callback, callback 回调给 element-ui 做后续的错误，典型的就是显示错误信息。
 */
export function validateUsername(rule, username, callback){
    let r = Validator.validateUserName(username);  // 检查语法
    console.log('validate username return', r);
    // 返回的结果中，pass 表示的是否通过的意思。
    if(r.pass == true){
        __isUsernameValid(username, callback);  // 语法检测通过后，异步检查是否合法
    }else{
        callback(new Error(r.error));
    }
}

export function validateEmail(rule, email, callback){
    let r = Validator.validateEmail(email);
    console.log('validate email return', r);
    if(r.pass == true){
        __checkEmailDuplicates(email, callback);
    }else{
        callback(new Error(r.error));
    }
}


export function validateAccountName(rule, value, callback){
    if (value === ''){
        callback(new Error('请输入账户名'));
    }else{
        let r =  Validator.validateAccountName(value);
        // 返回的结果中，pass 表示的是否通过的意思。
        if(r.pass == true){
            callback();
        }else{
            callback(new Error(r.error));
        }
    }

}


/**
 * 注意，要能够复用，则表单的名字必须统一，这里使用 vform
 * @param rule
 * @param value
 * @param callback
 */
export function validatePassword(rule, value, callback){
    if (value === '') {
        callback(new Error('请输入密码'));
    }else{
        let r = Validator.validatePassword(value);
        console.log('validate password return', r);
        // 返回的结果中，pass 表示的是否通过的意思。
        if(r.pass == true){
            callback();
        }else{
            callback(new Error(r.error));
        }
    }
}

export function validateOldPassword(rule, value, callback){
    if (value === '') {
        callback(new Error('请输入密码'));
    }else{
        let r = Validator.validatePassword(value);
        if(r.pass === true){
            __checkPassword(value, callback);
        }else{
            callback(new Error(r.error));
        }
    }
}

/**
 * 注意，要能够复用，则表单的名字必须统一，这里使用 vform；并且指定第一次输入的密码的 field name 为 password.
 *
 * @param rule
 * @param value
 * @param callback
 */
export function validatePassword2(rule, value, callback){
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.vform.password) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
}

/**
 *
 * @param rule
 * @param value
 * @param callback
 */
export function validateInviteCode(rule, value, callback){
    this.inviteCode.showSuccess = false;
    if(value === null || value.trim() === '') {
        callback();
        this.$refs['inviteCode'].resetField(); // 还原成最初的样子。
    }else{
        let r = Validator.validateInviteCode(value)
        console.log('validate invite code return', r);
        // 返回的结果中，pass 表示的是否通过的意思。
        if(r.pass === true){
            isValid(value).then((r)=>{
                if(r.pass){
                    callback();
                    this.inviteCode.showSuccess = true;
                    this.inviteCode.successMessage = r.message;
                } else {
                    callback(new Error(r.error));
                }
            });
        }else{
            callback(new Error(r.error));
        }
    }
}

export function validateAggrement(rule, value, callback){
    if (value === false){
        callback(new Error('你没有同意协议，请同意协议！'));
    }else {
        callback();
    }
}

export function validateEmailActiviateCode(rule, value, callback){
    let r = Validator.validateEmailActiviateCode(value);
    if(!r.pass){
        callback(new Error(r.error))
    }else{
        // send to
        verifyEmailActivaiteCode(value).then((r)=>{
            console.log('========>', r);
            if(r.pass){
                callback();
            }else{
                callback(new Error(r.error));
            }
        })
    }
}

export function isEmailValid(rule, email, callback){
    let r = Validator.validateEmail(email);
    console.log('validate email return', r);
    if(r.pass == true){
        // __checkEmailDuplicates(email, callback);
        __isEmailExists(email, callback);
    }else{
        callback(new Error(r.error));
    }
}





// WEBPACK FOOTER //
// ./src/validator.js